
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-image-occlusion",
      function () {
        return require("private-next-pages/ai-image-occlusion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-image-occlusion"])
      });
    }
  